<template>
  <div class="personal-panel">
    <div
      class="personal-desc"
      :style="{ background: this.$store.state.app.themeColor }"
    >
      <div class="avatar-container">
        <img class="avatar" :src="require('@/assets/user.png')" />
      </div>
      <div class="name-role">
        <span class="sender">{{ user.nickName }} - {{ user.roleNames }}</span>
      </div>
      <div class="registe-info">
        <span class="registe-info">
          <li class="fa fa-clock-o"></li>
          {{ this.dateFormat(user.createTime) }}
        </span>
      </div>
    </div>
    <div class="personal-footer" @click="logout">
      <li class="fa fa-sign-out"></li>
      {{ $t("common.logout") }}
    </div>
  </div>
</template>

<script>
import { format } from "@/utils/datetime";
import Cookies from "js-cookie";
export default {
  name: "PersonalPanel",
  components: {},
  props: {
    user: {
      type: Object,
      default: {
        nickName: "admin",
        avatar: "@/assets/user.png",
        role: "超级管理员",
        registeInfo: "注册时间：2021-06-30 ",
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 退出登录
    logout() {
      this.$confirm("确认退出吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.logoutApi();
        })
        .catch(() => {});
    },
    logoutApi() {
      sessionStorage.removeItem("user");
      Cookies.set("token", ""); // 从cookie去掉token
      //登出时清掉数据
      this.$store.commit("setSelectedProjectInfo", {});
      this.$store.commit("setProjectInfos", []);
      this.$store.commit("setModelGroup", null);
      this.$store.commit("setLoadingStart", false);
      //
      this.$router.push("/login");
      this.$api.login
        .logout()
        .then((res) => {})
        .catch(function (res) {});
    },
    // 清除Cookie
    deleteCookie(name) {
      var myDate = new Date();
      myDate.setTime(-1000); // 设置过期时间
      document.cookie = name + "=''; expires=" + myDate.toGMTString();
    },
    // 时间格式化
    dateFormat(date) {
      return format(date);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.personal-panel {
  font-size: 14px;
  width: 280px;
  text-align: center;
  border-color: rgba(180, 190, 190, 0.2);
  border-width: 1px;
  border-style: solid;
  background: rgba(182, 172, 172, 0.1);
  margin: -14px;
}
.personal-desc {
  padding: 15px;
  color: #fff;
}
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 90px;
}
.name-role {
  font-size: 16px;
  padding: 5px;
}
.personal-relation {
  font-size: 16px;
  padding: 12px;
  margin-right: 1px;
  background: rgba(200, 209, 204, 0.3);
}
.relation-item {
  padding: 12px;
}
.relation-item:hover {
  cursor: pointer;
  color: rgb(19, 138, 156);
}
.main-operation {
  padding: 8px;
  margin-right: 1px;
  /* background: rgba(175, 182, 179, 0.3); */
  border-color: rgba(201, 206, 206, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.main-operation-item {
  margin: 15px;
}
.other-operation {
  padding: 15px;
  margin-right: 1px;
  text-align: left;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.other-operation-item {
  padding: 12px;
}
.other-operation-item:hover {
  cursor: pointer;
  background: #9e94941e;
  color: rgb(19, 138, 156);
}
.personal-footer {
  margin-right: 1px;
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.personal-footer:hover {
  cursor: pointer;
  color: rgb(19, 138, 156);
  background: #b1a6a61e;
}
</style>


// WEBPACK FOOTER //
// src/views/Core/PersonalPanel.vue